import { AbsoluteFill, getRemotionEnvironment } from 'remotion';
import ElementsTrackComponent from './ElementsTrackComponent';
import SegmentsTrackComponent from './SegmentsTrackComponent';
import { CompositionConfig } from '../../MainPlayer/types/CompositionConfig';
import { CaptionsTrackComponent } from './CaptionsTrackComponent';
import { Track } from '@/App/remotion/MainPlayer/types/Track/Track';
import { TrackType } from '@/App/remotion/MainPlayer/types/Track/Type';
import { ElementsTrack } from '@/App/remotion/MainPlayer/types/Track/ElementsTrack';

const TrackComponent: React.FC<{
  track: Track;
  elementTracks?: ElementsTrack[];
  canEditCaptions?: boolean;
  canEditSpeakerLabel?: boolean;
  disableCaptionsDragging?: boolean;
  disableCaptionsResize?: boolean;
  canEditImages?: boolean;
  canEditTextElements?: boolean;
  canEditVideos?: boolean;
  canManuallyReposition?: boolean;
  preventOverlappingWithOtherCrops?: boolean;
  canEditLottie?: boolean;
  onOutlineRelease: CompositionConfig['onOutlineRelease'];
  onOutlineResize: CompositionConfig['onOutlineResize'];
}> = ({
  track,
  elementTracks,
  canEditCaptions = true,
  canEditSpeakerLabel = false,
  disableCaptionsDragging = false,
  disableCaptionsResize = false,
  canEditImages = false,
  canEditTextElements = false,
  canEditVideos = false,
  canManuallyReposition = false,
  preventOverlappingWithOtherCrops = false,
  canEditLottie = false,
  onOutlineRelease,
  onOutlineResize
}) => {
  const { type } = track;

  const isPreview = getRemotionEnvironment().isPlayer;

  if (type === TrackType.ELEMENTS) {
    return (
      <ElementsTrackComponent
        elements={track.elements}
        source="TRACK"
        canEditSpeakerLabel={canEditSpeakerLabel}
        canEditImages={isPreview && canEditImages}
        canEditTextElements={isPreview && canEditTextElements}
        canEditVideos={isPreview && canEditVideos}
        canEditLottie={isPreview && canEditLottie}
        onOutlineRelease={onOutlineRelease}
      />
    );
  }

  if (type === TrackType.SEGMENTS) {
    return (
      <SegmentsTrackComponent
        segments={track.segments}
        segmentTransitions={track.segmentTransitions}
        canEditSpeakerLabel={canEditSpeakerLabel}
        canManuallyReposition={canManuallyReposition}
        preventOverlappingWithOtherCrops={preventOverlappingWithOtherCrops}
      />
    );
  }

  if (type === TrackType.CAPTIONS) {
    return (
      <CaptionsTrackComponent
        track={track}
        elementTracks={elementTracks}
        onOutlineRelease={onOutlineRelease}
        onOutlineResize={onOutlineResize}
        disableCaptionsDragging={disableCaptionsDragging}
        disableCaptionsResize={disableCaptionsResize}
        canEditCaptions={canEditCaptions}
      />
    );
  }

  return <AbsoluteFill>Please contact support!</AbsoluteFill>;
};

export default TrackComponent;
